enum FoundationRoute {
  APPLICATION       = '/application',
  CUSTOM_ROUTE      =  '/custom-route',
  FORGOT_PASSWORD   = '/forgot-password',
  INACTIVITY        = '/inactivity',
  LOGIN             = '/login',
  SPOTLIGHT         = '/spotlight',
}

enum ModulesRoute {
  APPROVALS           = '/application/approvals',
  PROFILE             = '/application/profile',
  USER_TERMS_LIST     = '/application/user-details',
  BED_MANAGEMENT      = '/application/bed-management',
}

enum ApplicationRoute {
  APPROVAL_LIST           = '/list',
  APPROVAL_ITEM           = '/items/:id/:processId',
  DISAPPROVE              = '/disapprove',
  FORWARD                 = '/forward',
  INFORM_OPINION          = '/inform-opinion',
  OPINION_REQUEST         = '/opinion',
  PRIVACY_NOTICE_DETAIL   = '/user-details/:nrSequencia/privacy-notice-detail',
  PURCHASE_APPROVAL       = '/purchase',
  TERMOS_OF_USE_DETAIL    = '/user-details/:nrSequencia/terms-of-use-detail',
  APPROVALS_ATTACHMENTS   = '/attachments',
}

export {
  ApplicationRoute,
  ModulesRoute,
  FoundationRoute,
};
